export default "__VITE_ASSET__d3a15ff5__"